export const PPT_LOCAL_LIMIT=50*1024*1024;
export function serverPpt(name,size,native=false){
 if(native||!/^pptx?$/i.test(String(name||'').split('.').pop()))return false;
 if(Number(size)>200*1024*1024)throw new Error('PPT超过200MB，请下载原文件查看');
 return !Number(size)||Number(size)>PPT_LOCAL_LIMIT;
}

// One visible page and at most its two neighbours. Closing releases late results too.
export function createSlideSession(transport,changed,{schedule=setTimeout,cancel=clearTimeout,now=Date.now}={}){
 const state={phase:'loading',message:'正在准备服务器预览…',pages:0,index:1,src:'',busy:false,error:''};
 const cache=new Map(),pending=new Map();let alive=true,active=true,timer,job='',serial=0,quality='screen',polls=0,started=now();
 const notify=()=>{if(alive)changed({...state})};
 function trim(){for(const [key,value] of cache)if(Math.abs(Number(key.split(':')[0])-state.index)>1){cache.delete(key);transport.release(value)}}
 async function image(page,kind){
  const key=page+':'+kind;
  if(cache.has(key))return cache.get(key);
  if(pending.has(key))return pending.get(key);
  while(pending.size>=3){await Promise.race(Array.from(pending.values(),value=>value.catch(()=>{})));if(!alive||Math.abs(page-state.index)>1)return null;if(cache.has(key))return cache.get(key);if(pending.has(key))return pending.get(key)}
  const result=(async()=>{
   const value=await transport.page({job,page,quality:kind});
   if(!alive||Math.abs(page-state.index)>1){transport.release(value);return null}
   cache.set(key,value);trim();return value;
  })();pending.set(key,result);
  try{return await result}finally{pending.delete(key)}
 }
 async function select(index,kind=quality){
  if(!alive||state.phase!=='ready'||!Number.isInteger(index)||index<1||index>state.pages)return;
  const current=++serial;quality=kind;state.index=index;state.busy=true;state.error='';state.src='';trim();notify();
  try{
   const src=await image(index,kind);
   if(alive&&current===serial){state.src=src||'';state.busy=false;notify();for(const page of [index-1,index+1])if(page>0&&page<=state.pages)image(page,'screen').catch(()=>{})}
  }catch(error){if(alive&&current===serial){state.busy=false;state.error=error.message||'页面加载失败，请重试';notify()}}
 }
 async function poll(retry=false){
  if(!alive||!active)return;cancel(timer);state.error='';notify();
  try{
   const result=await transport.status(retry);if(!alive||!active)return;
   state.message=String(result.message||'正在生成预览…');state.phase=result.state;
   if(result.state==='ready'){
    if(!/^[a-f0-9]{64}$/.test(result.job)||!Number.isInteger(result.pages)||result.pages<1||result.pages>500)throw new Error('预览数据无效');
    job=result.job;state.pages=result.pages;notify();await select(Math.min(state.index,state.pages));return;
   }
   if(result.state==='failed')throw new Error(state.message);
   if(!['queued','converting','rendering'].includes(result.state))throw new Error('预览状态无效');
   notify();
   if(now()-started>15*60*1000)throw new Error('服务器仍在处理文档，可稍后重试或下载原文件');
   timer=schedule(()=>poll(),++polls<4?2000:5000);
  }catch(error){if(alive&&active){state.error=error.message||'预览服务连接失败，请重试';state.busy=false;notify()}}
 }
 function close(){alive=false;serial++;cancel(timer);for(const value of cache.values())transport.release(value);cache.clear()}
 return {start:()=>poll(),select,retry(){started=now();return state.phase==='ready'?select(state.index):poll(true)},quality:value=>value===quality?Promise.resolve():select(state.index,value),active(value){active=value;cancel(timer);if(value&&state.phase!=='ready')poll()},close};
}
